angular.module('portainer.integrations', ['portainer.integrations.storidge']);
